import React from "react";
import { PropTypes } from "prop-types";

import styles from "./../styles/components/textarea.module.scss";

export const Textarea = props => {
    const disabledStyle = props.disabled ? styles.__disabled : '';
  return (
    <>
      <section className={styles.__outer}>
        <h4 className={styles.__text_left}>{props.label}</h4>
        <section id={props.id} className={[styles.__bound, props.hasError ? styles.__hasError : '', disabledStyle].join(" ")}>
          <textarea 
            {...props.input}
            disabled={props.disabled}
            name={props.name} 
            style={{height:'200px',resize: 'none'}} 
            className={styles.__field} />
        </section>
        { props.submitFailed && props.error && (
        <label className="">{props.error}</label>
      )}
      </section>
    </>
  );
};

Textarea.propTypes = {
  advice: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string
  }),
  label: PropTypes.string,
  meta: PropTypes.shape({
    error: PropTypes.string,
    submitFailed: PropTypes.bool
  })
};
